module.exports = __webpack_public_path__ + "img/gy_img1.ceba1970.png";